import React from "react";
import styled from "styled-components";

import Fieldset from "./styled/fieldset";
import Legend from "./styled/legend";
import HeadingCell from "./styled/heading_cell";

import {EnhancedLlmRun} from "common/flowmaster/types/llm_run";
import TextCopier from "./actions/text_copier";

interface Props {
  llmRun: EnhancedLlmRun;
}

const InputRow = styled.tr`
  & th,
  & td {
    padding: 0.25em 1em;
  }
  & th:not(:last-child),
  & td:not(:last-child) {
    border-right: 1px solid #ddd;
  }
`;

const InputCell = styled.td`
  :not(:last-child) {
    border-right: 1px solid #ddd;
    padding-right: 1em;
  }
`;

export default function Inputs({llmRun}: Props) {
  return (
    <Fieldset>
      <Legend>Variable</Legend>
      <table style={{tableLayout: "fixed", width: "100%"}}>
        <thead>
          <InputRow>
            <HeadingCell style={{width: "5em"}}>key</HeadingCell>
            <HeadingCell style={{width: "100%"}}>value</HeadingCell>
          </InputRow>
        </thead>
        <tbody>
          {Object.entries(llmRun.data.data_store?.variable ?? []).map(
            ([key, value]) => {
              return (
                <InputRow key={key}>
                  <InputCell>{key}</InputCell>
                  <InputCell>
                    <TextCopier
                      text={
                        typeof value === "object"
                          ? JSON.stringify(value, null, 2)
                          : value
                      }
                    />
                  </InputCell>
                </InputRow>
              );
            },
          )}
        </tbody>
      </table>
    </Fieldset>
  );
}
